import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './PostFeeling.css';
const PostFeeling = ({ feelingData }) => {
  if (!feelingData) return null;
  
  let parsedFeeling;
  
  // Si le feeling est déjà un objet, on l'utilise directement
  if (typeof feelingData === 'object') {
    parsedFeeling = feelingData;
  } else {
    // Sinon, on essaie de le parser
    try {
      parsedFeeling = JSON.parse(feelingData);
    } catch (e) {
      console.error("Erreur lors du parsing du feeling:", e);
      return null;
    }
  }
  
  // Si le feeling n'a pas les propriétés attendues, on ne l'affiche pas
  if (!parsedFeeling || !parsedFeeling.icon || !parsedFeeling.label) {
    return null;
  }

  return (
    <div className="post-feeling">
      <span className="post-feeling-icon">{parsedFeeling.icon}</span>
      <span className="post-feeling-text">se sent {parsedFeeling.label}</span>
    </div>
  );
};

export { PostFeeling };